import { render, staticRenderFns } from "./Carrossel.vue?vue&type=template&id=72b46cc0&"
import script from "./Carrossel.vue?vue&type=script&lang=js&"
export * from "./Carrossel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports